import React from 'react'
import { Button, Tab, Tabs, Tooltip } from '@mui/material'
import { inc, dec, onlyPopulatedValues } from 'app/util'
import {
  // prettier-ignore
  isEmpty,
  last,
  unset,
} from 'lodash/fp'
import CancelIcon from '@mui/icons-material/Cancel'
import { CampaignSchedule, PublishCampaignDTO } from '@marketing-milk/interfaces'
// TODO:  remove this type when the correct type is inside of mono repo
import { AdCreativeGroup } from '../../../CampaignForm'
import { toast } from 'react-toastify'
import { getCostPerText } from '../../../../helpers/campaignForm.helpers'

type Props = {
  adGroups: AdCreativeGroup[]
  setAdCreativeGroups: SetState<AdCreativeGroup[]>
  adGroupIndex: number
  setAdCreativeGroupIndex: SetState<number>
  campaignDto: PublishCampaignDTO
  schedule?: CampaignSchedule
}

export const CascadingCampaignOptions = ({
  adGroups,
  setAdCreativeGroups,
  adGroupIndex,
  setAdCreativeGroupIndex,
  campaignDto,
  schedule,
}: Props) => {
  return (
    <div className="flex items-center justify-center w-full">
      <Tabs value={adGroupIndex} centered scrollButtons="auto">
        {adGroups.map((_, index) => (
          <div className="px-2 relative">
            {index > 1 && (
              <button
                data-testid="cc-remove-variation-button"
                className="absolute z-20 right-0 bg-transparent"
                onClick={() => {
                  setAdCreativeGroups(groups => onlyPopulatedValues(unset(adGroupIndex, groups)))
                  setAdCreativeGroupIndex(dec)
                }}
              >
                <CancelIcon color="error" />
              </button>
            )}
            <Tab
              label={`${index > 0 ? ' Variation' : 'Main Ad Group'} ${
                index > 0 ? '#' + index : ''
              }  `}
              onClick={() => setAdCreativeGroupIndex(index)}
              value={index}
            />
          </div>
        ))}
      </Tabs>

      <div className="ml-5">
        <Tooltip title="If your current Ad Group isn't performing well, the backup group will replace them">
          <Button
            disabled={!!isEmpty(last(adGroups || []))}
            variant="contained"
            onClick={() => {
              if (schedule) {
                toast.info(
                  `Performance will be checked every ${schedule.interval} ${
                    schedule.intervalType
                  }(s) and switch if ${getCostPerText(campaignDto.campaign.goal)} is less than $${
                    campaignDto.campaign.maxCostPer ?? 10
                  }`
                )
              }
              setAdCreativeGroups(prev => [...prev, []])
              setAdCreativeGroupIndex(inc)
            }}
          >
            Add Variation
          </Button>
        </Tooltip>
      </div>
    </div>
  )
}
